import type { ReactNode } from 'react';
import type { TablerIcon } from '@tabler/icons-react';
import styles from './AssetDetailPageView.module.css';

type Props = {
  icon: TablerIcon;
  children: ReactNode;
};

export function AssetDetailTabLabel({ icon: Icon, children }: Props) {
  return (
    <span className={styles.tabLabel}>
      <Icon size={16} stroke={1.75} aria-hidden />
      <span className={styles.tabLabelText}>{children}</span>
    </span>
  );
}
